import { useEffect, useRef, useState } from "react";
import { Divider, Grid } from "@mui/material";

//import styles
import "./base-title.scss";

function BaseTitle({ title, dividerColor, button }) {

    // Refs for measuring component widths
    const containerRef = useRef();
    const titleRef = useRef();
    const buttonRef = useRef();

    // Calculate divider width based on container, title and button widths
    const calculateDividerWidth = () => {
        const containerWidth = containerRef?.current?.offsetWidth;
        const titleWidth = titleRef?.current?.offsetWidth;
        const buttonWidth = buttonRef?.current?.offsetWidth || 0;
        const spacing = 30;

        return containerWidth - (titleWidth + buttonWidth) - spacing;
    };

    const [dividerWidth, setDividerWidth] = useState(calculateDividerWidth());
    useEffect(() => {
        setDividerWidth(calculateDividerWidth());
    }, [title, dividerColor, button]);

    return (
        <Grid
            className="base-title"
            container
            item
            xs={12}
            justifyContent="space-between"
            alignItems="center"
            ref={containerRef}
        >
            <span className="base-title__title" ref={titleRef}>
                {title}
            </span>
            <Divider sx={{ width: dividerWidth, borderBottom: dividerColor }} />
            {!!button && (
                <div className="base-title__button" ref={buttonRef}>
                    {button}
                </div>
            )}
        </Grid>
    );
}

export default BaseTitle;
